
function Retailers() {

    document.addEventListener('DOMContentLoaded', function() {
    var $component = $('.c-retailers');
    
    if (!$component.length) return;

    var $container = $component.find('.c-retailers__container');
    var $toggle = $component.find('.c-retailers__view-all-btn');
    var $toggleText = $toggle.text();

    // determines whether to hide 'view more' retailers
    function onBreakpointChange(msg, bp) {
        if (bp === 'tablet-landscape') bp = 'tablet'
        var showing = parseInt($component.attr('data-show-' + bp), 10);
        
        // check for only 2 buttons - audio book
        // (https://staging.chookdigital.net/penguin.com.au/books/any-ordinary-day-9780143792819)
        var noOfRetailers = $container.find('.c-retailers__retailer').length;
        if (noOfRetailers <= showing) {
            $toggle.css('display', 'none');
        } else {
            $toggle.css('display', 'inline-block');
        }
    }
    PubSub.subscribe('app:breakpoint.change', onBreakpointChange)

    $toggle.click(function() {
        var isOpen = $container.hasClass('is-open');
        if (!isOpen) {
            // open
            $container.addClass('is-open');
            $toggle.text('Close');
        } else {
            // close
            $container.removeClass('is-open');
            // $toggle.text('View all online retailers');
            $toggle.text($toggleText);
        }
    });
});

}

export default Retailers;